/* eslint-disable */
import * as Types from '../../../../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetRegionVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetRegionDTO = (
  { __typename?: 'Query' }
  & { region: (
    { __typename?: 'Region' }
    & Pick<Types.RegionDTO, 'id' | 'name'>
    & { country: (
      { __typename?: 'Country' }
      & Pick<Types.CountryDTO, 'id'>
    ), temperatures?: Types.Maybe<Array<(
      { __typename?: 'TypeTemperature' }
      & Pick<Types.TypeTemperatureDTO, 'type' | 'temperature'>
    )>> }
  ) }
);


export const GetRegionDocumentDTO = gql`
    query getRegion($id: String!) {
  region(id: $id) {
    id
    name
    country {
      id
    }
    temperatures {
      type
      temperature
    }
  }
}
    `;

/**
 * __useGetRegion__
 *
 * To run a query within a React component, call `useGetRegion` and pass it any options that fit your needs.
 * When your component renders, `useGetRegion` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegion({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRegion(baseOptions: Apollo.QueryHookOptions<GetRegionDTO, GetRegionVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionDTO, GetRegionVariablesDTO>(GetRegionDocumentDTO, options);
      }
export function useGetRegionLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionDTO, GetRegionVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionDTO, GetRegionVariablesDTO>(GetRegionDocumentDTO, options);
        }
export type GetRegionHookResult = ReturnType<typeof useGetRegion>;
export type GetRegionLazyQueryDTOHookResult = ReturnType<typeof useGetRegionLazyQueryDTO>;
export type GetRegionQueryResultDTO = Apollo.QueryResult<GetRegionDTO, GetRegionVariablesDTO>;